import axios from 'axios'
import store from '@/store'

// const url = 'http://test.unim.internal/'

function ApiException (code, body) {
  this.code = code
  this.body = body
  this.name = 'ApiException'
}

ApiException.prototype.toString = () => this.name + ': "' + this.body + '" (' + this.code + ')'

export function parseResponse (response) {
  if (response.data.message !== 'SUCCESS') {
    throw new ApiException(response.message, response.errors)
  }
  return response.data.data
}

export const getObjects = async (type, locale = "RUS", text = "") => {
  if (!type) {
    return {}
  }
  if (text) {
    return await axios.get(`/thesaurus/documents?type=${type}&locale=${locale}&text=${text}`)
  }
    return await axios.get(`/thesaurus/documents?type=${type}&locale=${locale}`)
}

export default {
  async getAllRegions() {
    const response = await getObjects("fias.regions")
    return parseResponse(response)
  },
  async getRegionByName(name) {
    const response = await getObjects("fias.regions", "RUS", name)
    return parseResponse(response)
  }
}



// WEBPACK FOOTER //
// ./src/thesaurus-api.js